var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 94,
    viewBox: "0 0 112 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5565 0.726562C90.6243 0.726562 97.9119 4.09552 103.089 9.50358C107.966 14.6102 110.962 21.5254 110.962 29.1499C110.962 36.8808 107.877 43.8847 102.859 49.009C97.6991 54.2753 90.5002 57.5556 82.5565 57.5556C82.5388 57.5556 82.5211 57.5556 82.5033 57.5556V0.726562C82.5211 0.726562 82.5388 0.726562 82.5565 0.726562Z",
    fill: "#A1F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1505 29.1322C54.1505 21.5077 57.1471 14.5925 62.0232 9.48585C67.183 4.09552 74.4529 0.744294 82.5029 0.726562V57.5378C74.5593 57.5201 67.3781 54.2575 62.236 48.9913C57.2357 43.8847 54.1505 36.8631 54.1505 29.1322Z",
    fill: "#5BE4E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4415 29.1326C53.4415 21.65 56.2785 14.8411 60.9241 9.66359L60.9064 9.64586L61.527 8.9898C64.2221 6.17051 67.3783 3.97182 70.9423 2.41146C74.3645 0.92203 78.0349 0.106388 81.8116 0.0177311C82.0599 0.0177311 82.3081 0 82.5564 0C82.8046 0 83.0528 -2.70823e-07 83.3011 0.0177311C87.0778 0.106388 90.7305 0.92203 94.1881 2.4292C97.7344 3.97182 100.908 6.18824 103.603 9.00753L104.224 9.66359L104.206 9.68132C108.852 14.8411 111.689 21.6677 111.689 29.1503C111.689 36.7394 108.781 43.6546 104.011 48.8321L104.047 48.8499L103.408 49.5059C97.8762 55.1622 90.4823 58.2652 82.5918 58.2652C74.6836 58.2652 67.2897 55.1622 61.7752 49.5059L61.1369 48.8499L61.1723 48.8321C56.3494 43.6369 53.4415 36.7216 53.4415 29.1326ZM65.9243 28.4234C65.9953 22.9089 66.935 17.6427 68.6372 13.1389C66.2967 12.4119 64.1335 11.5076 62.183 10.4083C57.8034 15.178 55.055 21.4904 54.8777 28.4234H65.9243ZM69.2933 46.793C67.1833 47.4314 65.2151 48.2293 63.442 49.1691C66.9528 52.5203 71.3324 54.9495 76.1908 56.102C74.134 54.6303 72.2544 52.4316 70.6586 49.5769C70.1799 48.6903 69.7188 47.7505 69.2933 46.793ZM71.9175 48.8676C74.79 53.992 78.5668 56.829 82.5564 56.829C86.5459 56.829 90.3227 54.0097 93.1952 48.8676C93.6384 48.0874 94.0463 47.2541 94.4364 46.3852C90.7837 45.4277 86.7409 44.9135 82.5741 44.9135C78.3895 44.9135 74.3645 45.4277 70.7118 46.3852C71.0664 47.2541 71.4743 48.0874 71.9175 48.8676ZM94.4364 49.5769C92.8405 52.4316 90.961 54.6303 88.9042 56.102C93.7803 54.9495 98.1599 52.5203 101.653 49.1691C99.8799 48.2293 97.9117 47.4314 95.8017 46.793C95.3939 47.7505 94.9328 48.6903 94.4364 49.5769ZM82.5564 43.495C86.936 43.495 91.1561 44.0447 94.986 45.0554C96.7237 40.6048 97.6812 35.3741 97.7699 29.8419H67.3606C67.4315 35.3563 68.4067 40.6048 70.1444 45.0554C73.9566 44.0447 78.1767 43.495 82.5564 43.495ZM97.7521 28.4234C97.6812 23.033 96.7592 17.9087 95.0924 13.529C91.227 14.5752 86.9715 15.1248 82.5386 15.1248C78.1058 15.1248 73.8503 14.5752 69.9848 13.529C68.3358 17.9087 67.4138 23.033 67.3251 28.4234H97.7521ZM82.5564 1.43624C78.5668 1.43624 74.79 4.27326 71.9175 9.39762C71.4211 10.2842 70.96 11.2239 70.5522 12.1992C74.2403 13.1921 78.3186 13.7063 82.5564 13.7063C86.7941 13.7063 90.8724 13.1921 94.5605 12.1992C94.1349 11.2239 93.6916 10.2842 93.1952 9.39762C90.3227 4.27326 86.5459 1.45397 82.5564 1.43624C82.5741 1.43624 82.5564 1.43624 82.5564 1.43624ZM69.1692 11.7913C69.6302 10.7097 70.1267 9.66359 70.6763 8.68836C72.2722 5.83362 74.1517 3.63493 76.2085 2.16322C71.226 3.33349 66.7577 5.86908 63.2114 9.32669C65.02 10.3196 67.0237 11.1353 69.1692 11.7913ZM88.9219 2.18096C90.9787 3.65266 92.8583 5.85135 94.4541 8.70609C95.0038 9.68132 95.5002 10.7275 95.9613 11.8091C98.1067 11.153 100.11 10.3196 101.919 9.34442C98.355 5.88681 93.9044 3.35123 88.9219 2.18096ZM96.4932 13.1389C98.1777 17.6427 99.1174 22.9089 99.2061 28.4234H110.253C110.075 21.4904 107.345 15.178 102.947 10.4083C100.997 11.4899 98.816 12.4119 96.4932 13.1389ZM99.1884 29.8596C99.1174 35.4982 98.1245 40.8885 96.3513 45.4632C98.6387 46.1724 100.784 47.059 102.717 48.1052C107.238 43.3 110.058 36.8989 110.235 29.8596H99.1884ZM68.7614 45.4632C66.9882 40.8885 66.013 35.4982 65.9243 29.8596H54.8777C55.055 36.9167 57.892 43.3177 62.3958 48.1052C64.3285 47.0413 66.4563 46.1547 68.7614 45.4632Z",
    fill: "#3D7E9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5034 56.8313C82.5211 56.8313 82.5389 56.8313 82.5566 56.8313C86.5461 56.8313 90.3229 54.012 93.1954 48.8699C93.6387 48.0897 94.0465 47.2564 94.4366 46.3875C90.7839 45.43 86.7412 44.9158 82.5743 44.9158C82.5566 44.9158 82.5389 44.9158 82.5211 44.9158V43.4796C82.5389 43.4796 82.5566 43.4796 82.5743 43.4796C86.954 43.4796 91.174 44.0292 95.004 45.0399C96.7417 40.5894 97.6992 35.3586 97.7878 29.8264H82.5389V28.3902H97.7878C97.7169 22.9999 96.7949 17.8755 95.1281 13.4958C91.2627 14.542 87.0072 15.0917 82.5743 15.0917C82.5566 15.0917 82.5389 15.0917 82.5211 15.0917V13.6554C82.5389 13.6554 82.5566 13.6554 82.5743 13.6554C86.8121 13.6554 90.8903 13.1412 94.5784 12.1483C94.1529 11.173 93.7096 10.2333 93.2131 9.34671C90.3229 4.27554 86.5461 1.45626 82.5743 1.43853H82.5566H82.5389C82.5211 1.43853 82.5211 1.43853 82.5034 1.43853V0.0200195C82.5211 0.0200195 82.5389 0.0200195 82.5566 0.0200195C82.8048 0.0200195 83.0531 0.0200193 83.3013 0.0377506C87.0781 0.126407 90.7307 0.942049 94.1884 2.44921C97.7346 3.99184 100.909 6.20826 103.604 9.02755L104.224 9.68361L104.207 9.70134C108.852 14.8612 111.689 21.6877 111.689 29.1704C111.689 36.7594 108.781 43.6746 104.012 48.8522L104.047 48.8699L103.409 49.526C97.8765 55.1823 90.4825 58.2853 82.5921 58.2853C82.5743 58.2853 82.5566 58.2853 82.5389 58.2853V56.8313H82.5034ZM88.9221 2.18324C90.979 3.65495 92.8585 5.85364 94.4543 8.70838C95.004 9.68361 95.5005 10.7298 95.9615 11.8114C98.107 11.1553 100.111 10.3219 101.919 9.34671C98.3552 5.8891 93.9047 3.35351 88.9221 2.18324ZM102.948 10.4106C100.997 11.4922 98.834 12.4142 96.4934 13.1412C98.1779 17.645 99.1177 22.9112 99.2063 28.4256H110.253C110.058 21.4927 107.327 15.1803 102.948 10.4106ZM110.235 29.8619H99.1886C99.1177 35.5005 98.1247 40.8908 96.3516 45.4655C98.6389 46.1747 100.784 47.0613 102.717 48.1075C107.239 43.3023 110.058 36.9012 110.235 29.8619ZM101.671 49.1536C99.8979 48.2138 97.9297 47.4159 95.8196 46.7776C95.3941 47.7528 94.9331 48.6749 94.4366 49.5614C92.8408 52.4162 90.9613 54.6149 88.9044 56.0866C93.7805 54.9518 98.1602 52.5048 101.671 49.1536Z",
    fill: "#3D7E9C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7989 24.0461H59.3457V81.213H11.7989V24.0461Z",
    fill: "#ECF9FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 29.1855H55.2864V30.1871H43.2942V29.1855Z",
    fill: "#8DC2C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 29.1855H41.7656V30.1871H29.7735V29.1855Z",
    fill: "#8DC2C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 29.1855H28.2449V30.1871H16.2527V29.1855Z",
    fill: "#8DC2C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 31.241H55.2864V32.2425H43.2942V31.241Z",
    fill: "#8DC2C4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 31.241H41.7656V32.2425H29.7735V31.241Z",
    fill: "#8DC2C4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 31.241H28.2449V32.2425H16.2527V31.241Z",
    fill: "#8DC2C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 33.2708H55.2864V34.2723H43.2942V33.2708Z",
    fill: "#8DC2C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 33.2708H41.7656V34.2723H29.7735V33.2708Z",
    fill: "#8DC2C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 33.2708H28.2449V34.2723H16.2527V33.2708Z",
    fill: "#8DC2C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 35.3H55.2864V36.3016H43.2942V35.3Z",
    fill: "#8DC2C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 35.3H41.7656V36.3016H29.7735V35.3Z",
    fill: "#8DC2C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 35.3H28.2449V36.3016H16.2527V35.3Z",
    fill: "#8DC2C4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 37.3293H55.2864V38.3309H43.2942V37.3293Z",
    fill: "#8DC2C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 37.3293H41.7656V38.3309H29.7735V37.3293Z",
    fill: "#8DC2C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 37.3293H28.2449V38.3309H16.2527V37.3293Z",
    fill: "#8DC2C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 39.3853H55.2864V40.3868H43.2942V39.3853Z",
    fill: "#8DC2C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 39.3853H41.7656V40.3868H29.7735V39.3853Z",
    fill: "#8DC2C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 39.3853H28.2449V40.3868H16.2527V39.3853Z",
    fill: "#8DC2C4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 41.4148H55.2864V42.4163H43.2942V41.4148Z",
    fill: "#8DC2C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 41.4148H41.7656V42.4163H29.7735V41.4148Z",
    fill: "#8DC2C4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 41.4148H28.2449V42.4163H16.2527V41.4148Z",
    fill: "#8DC2C4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 43.4438H55.2864V44.4454H43.2942V43.4438Z",
    fill: "#8DC2C4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 43.4438H41.7656V44.4454H29.7735V43.4438Z",
    fill: "#8DC2C4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 43.4438H28.2449V44.4454H16.2527V43.4438Z",
    fill: "#8DC2C4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 45.4741H55.2864V46.4757H43.2942V45.4741Z",
    fill: "#8DC2C4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 45.4741H41.7656V46.4757H29.7735V45.4741Z",
    fill: "#8DC2C4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 45.4741H28.2449V46.4757H16.2527V45.4741Z",
    fill: "#8DC2C4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 47.5303H55.2864V48.5318H43.2942V47.5303Z",
    fill: "#8DC2C4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 47.5303H41.7656V48.5318H29.7735V47.5303Z",
    fill: "#8DC2C4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 47.5303H28.2449V48.5318H16.2527V47.5303Z",
    fill: "#8DC2C4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 49.5586H55.2864V50.5601H43.2942V49.5586Z",
    fill: "#8DC2C4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 49.5586H41.7656V50.5601H29.7735V49.5586Z",
    fill: "#8DC2C4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 49.5586H28.2449V50.5601H16.2527V49.5586Z",
    fill: "#8DC2C4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 51.5881H55.2864V52.5897H43.2942V51.5881Z",
    fill: "#8DC2C4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 51.5881H41.7656V52.5897H29.7735V51.5881Z",
    fill: "#8DC2C4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 51.5881H28.2449V52.5897H16.2527V51.5881Z",
    fill: "#8DC2C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 53.6182H55.2864V54.6197H43.2942V53.6182Z",
    fill: "#8DC2C4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 53.6182H41.7656V54.6197H29.7735V53.6182Z",
    fill: "#8DC2C4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 53.6182H28.2449V54.6197H16.2527V53.6182Z",
    fill: "#8DC2C4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 55.6733H55.2864V56.6749H43.2942V55.6733Z",
    fill: "#8DC2C4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 55.6733H41.7656V56.6749H29.7735V55.6733Z",
    fill: "#8DC2C4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 55.6733H28.2449V56.6749H16.2527V55.6733Z",
    fill: "#8DC2C4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 57.7029H55.2864V58.7044H43.2942V57.7029Z",
    fill: "#8DC2C4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 57.7029H41.7656V58.7044H29.7735V57.7029Z",
    fill: "#8DC2C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 57.7029H28.2449V58.7044H16.2527V57.7029Z",
    fill: "#8DC2C4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 59.7327H55.2864V60.7342H43.2942V59.7327Z",
    fill: "#8DC2C4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 59.7327H41.7656V60.7342H29.7735V59.7327Z",
    fill: "#8DC2C4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 59.7327H28.2449V60.7342H16.2527V59.7327Z",
    fill: "#8DC2C4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 61.762H55.2864V62.7635H43.2942V61.762Z",
    fill: "#8DC2C4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 61.762H41.7656V62.7635H29.7735V61.762Z",
    fill: "#8DC2C4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 61.762H28.2449V62.7635H16.2527V61.762Z",
    fill: "#8DC2C4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 63.8181H55.2864V64.8197H43.2942V63.8181Z",
    fill: "#8DC2C4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 63.8181H41.7656V64.8197H29.7735V63.8181Z",
    fill: "#8DC2C4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 63.8181H28.2449V64.8197H16.2527V63.8181Z",
    fill: "#8DC2C4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 65.8474H55.2864V66.849H43.2942V65.8474Z",
    fill: "#8DC2C4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 65.8474H41.7656V66.849H29.7735V65.8474Z",
    fill: "#8DC2C4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 65.8474H28.2449V66.849H16.2527V65.8474Z",
    fill: "#8DC2C4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 67.8765H55.2864V68.878H43.2942V67.8765Z",
    fill: "#8DC2C4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 67.8765H41.7656V68.878H29.7735V67.8765Z",
    fill: "#8DC2C4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 67.8765H28.2449V68.878H16.2527V67.8765Z",
    fill: "#8DC2C4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 69.9058H55.2864V70.9073H43.2942V69.9058Z",
    fill: "#8DC2C4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 69.9058H41.7656V70.9073H29.7735V69.9058Z",
    fill: "#8DC2C4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 69.9058H28.2449V70.9073H16.2527V69.9058Z",
    fill: "#8DC2C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 71.9619H55.2864V72.9635H43.2942V71.9619Z",
    fill: "#8DC2C4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 71.9619H41.7656V72.9635H29.7735V71.9619Z",
    fill: "#8DC2C4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2527 71.9619H28.2449V72.9635H16.2527V71.9619Z",
    fill: "#8DC2C4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 29.1855H41.7656V38.1731H29.7735V29.1855Z",
    fill: "#8DC2C4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7735 49.6382H41.7656V58.6257H29.7735V49.6382Z",
    fill: "#8DC2C4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0105 34.8787H94.5574V92.0456H47.0105V34.8787Z",
    fill: "#ECF9FB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 39.9915H90.4983V40.993H78.5062V39.9915Z",
    fill: "#8DC2C4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 39.9915H76.978V40.993H64.9859V39.9915Z",
    fill: "#8DC2C4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 39.9915H63.4304V40.993H51.4383V39.9915Z",
    fill: "#8DC2C4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 42.0471H90.4983V43.0487H78.5062V42.0471Z",
    fill: "#8DC2C4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 42.0471H76.978V43.0487H64.9859V42.0471Z",
    fill: "#8DC2C4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 42.0471H63.4304V43.0487H51.4383V42.0471Z",
    fill: "#8DC2C4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 44.0767H90.4983V45.0782H78.5062V44.0767Z",
    fill: "#8DC2C4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 44.0767H76.978V45.0782H64.9859V44.0767Z",
    fill: "#8DC2C4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 44.0767H63.4304V45.0782H51.4383V44.0767Z",
    fill: "#8DC2C4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 46.106H90.4983V47.1075H78.5062V46.106Z",
    fill: "#8DC2C4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 46.106H76.978V47.1075H64.9859V46.106Z",
    fill: "#8DC2C4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 46.106H63.4304V47.1075H51.4383V46.106Z",
    fill: "#8DC2C4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 48.1357H90.4983V49.1373H78.5062V48.1357Z",
    fill: "#8DC2C4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 48.1357H76.978V49.1373H64.9859V48.1357Z",
    fill: "#8DC2C4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 48.1357H63.4304V49.1373H51.4383V48.1357Z",
    fill: "#8DC2C4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 50.1917H90.4983V51.1932H78.5062V50.1917Z",
    fill: "#8DC2C4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 50.1917H76.978V51.1932H64.9859V50.1917Z",
    fill: "#8DC2C4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 50.1917H63.4304V51.1932H51.4383V50.1917Z",
    fill: "#8DC2C4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 52.2212H90.4983V53.2227H78.5062V52.2212Z",
    fill: "#8DC2C4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 52.2212H76.978V53.2227H64.9859V52.2212Z",
    fill: "#8DC2C4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 52.2212H63.4304V53.2227H51.4383V52.2212Z",
    fill: "#8DC2C4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 54.2502H90.4983V55.2518H78.5062V54.2502Z",
    fill: "#8DC2C4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 54.2502H76.978V55.2518H64.9859V54.2502Z",
    fill: "#8DC2C4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 54.2502H63.4304V55.2518H51.4383V54.2502Z",
    fill: "#8DC2C4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 56.2795H90.4983V57.2811H78.5062V56.2795Z",
    fill: "#8DC2C4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 56.2795H76.978V57.2811H64.9859V56.2795Z",
    fill: "#8DC2C4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 56.2795H63.4304V57.2811H51.4383V56.2795Z",
    fill: "#8DC2C4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 58.3354H90.4983V59.337H78.5062V58.3354Z",
    fill: "#8DC2C4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 58.3354H76.978V59.337H64.9859V58.3354Z",
    fill: "#8DC2C4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 58.3354H63.4304V59.337H51.4383V58.3354Z",
    fill: "#8DC2C4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 60.3655H90.4983V61.367H78.5062V60.3655Z",
    fill: "#8DC2C4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 60.3655H76.978V61.367H64.9859V60.3655Z",
    fill: "#8DC2C4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 60.3655H63.4304V61.367H51.4383V60.3655Z",
    fill: "#8DC2C4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 62.394H90.4983V63.3956H78.5062V62.394Z",
    fill: "#8DC2C4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 62.394H76.978V63.3956H64.9859V62.394Z",
    fill: "#8DC2C4"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 62.394H63.4304V63.3956H51.4383V62.394Z",
    fill: "#8DC2C4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 64.4238H90.4983V65.4254H78.5062V64.4238Z",
    fill: "#8DC2C4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 64.4238H76.978V65.4254H64.9859V64.4238Z",
    fill: "#8DC2C4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 64.4238H63.4304V65.4254H51.4383V64.4238Z",
    fill: "#8DC2C4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 66.48H90.4983V67.4815H78.5062V66.48Z",
    fill: "#8DC2C4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 66.48H76.978V67.4815H64.9859V66.48Z",
    fill: "#8DC2C4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 66.48H63.4304V67.4815H51.4383V66.48Z",
    fill: "#8DC2C4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 68.5093H90.4983V69.5108H78.5062V68.5093Z",
    fill: "#8DC2C4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 68.5093H76.978V69.5108H64.9859V68.5093Z",
    fill: "#8DC2C4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 68.5093H63.4304V69.5108H51.4383V68.5093Z",
    fill: "#8DC2C4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 70.5386H90.4983V71.5401H78.5062V70.5386Z",
    fill: "#8DC2C4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 70.5386H76.978V71.5401H64.9859V70.5386Z",
    fill: "#8DC2C4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 70.5386H63.4304V71.5401H51.4383V70.5386Z",
    fill: "#8DC2C4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 72.5679H90.4983V73.5694H78.5062V72.5679Z",
    fill: "#8DC2C4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 72.5679H76.978V73.5694H64.9859V72.5679Z",
    fill: "#8DC2C4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 72.5679H63.4304V73.5694H51.4383V72.5679Z",
    fill: "#8DC2C4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 74.624H90.4983V75.6256H78.5062V74.624Z",
    fill: "#8DC2C4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 74.624H76.978V75.6256H64.9859V74.624Z",
    fill: "#8DC2C4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 74.624H63.4304V75.6256H51.4383V74.624Z",
    fill: "#8DC2C4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 76.6528H90.4983V77.6544H78.5062V76.6528Z",
    fill: "#8DC2C4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 76.6528H76.978V77.6544H64.9859V76.6528Z",
    fill: "#8DC2C4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 76.6528H63.4304V77.6544H51.4383V76.6528Z",
    fill: "#8DC2C4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 78.6829H90.4983V79.6844H78.5062V78.6829Z",
    fill: "#8DC2C4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 78.6829H76.978V79.6844H64.9859V78.6829Z",
    fill: "#8DC2C4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 78.6829H63.4304V79.6844H51.4383V78.6829Z",
    fill: "#8DC2C4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 80.7124H90.4983V81.7139H78.5062V80.7124Z",
    fill: "#8DC2C4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 80.7124H76.978V81.7139H64.9859V80.7124Z",
    fill: "#8DC2C4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 80.7124H63.4304V81.7139H51.4383V80.7124Z",
    fill: "#8DC2C4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5062 82.7673H90.4983V83.7689H78.5062V82.7673Z",
    fill: "#8DC2C4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9859 82.7673H76.978V83.7689H64.9859V82.7673Z",
    fill: "#8DC2C4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4383 82.7673H63.4304V83.7689H51.4383V82.7673Z",
    fill: "#8DC2C4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9854 39.9915H90.4983V47.1077H64.9854V39.9915Z",
    fill: "#8DC2C4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5701 70.696H63.5623V79.6835H51.5701V70.696Z",
    fill: "#8DC2C4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36102 93.1516C1.33466 93.1516 1.28194 93.1516 1.25559 93.1516C0.93931 93.0989 0.754821 92.7826 0.807533 92.4927L1.62458 88.5129C1.67729 88.1966 1.99357 88.0121 2.28349 88.0648C2.59977 88.1176 2.78426 88.4338 2.73154 88.7238L1.91449 92.7036C1.83543 92.9671 1.59822 93.1516 1.36102 93.1516Z",
    fill: "#6E728F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0.64989 92.4134C0.64989 92.4134 0.307258 93.863 0.64989 93.9157C0.992523 93.9684 6.02658 94.1002 6.05294 93.863C6.15836 93.0723 2.04678 92.3343 1.62508 92.4134C1.22973 92.4925 0.676247 92.2025 0.64989 92.4134Z",
    fill: "#1A1C2E"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1923 93.1516C11.166 93.1516 11.1132 93.1516 11.0869 93.1516C10.7706 93.0989 10.5861 92.7826 10.6388 92.4927L11.4559 88.5129C11.5086 88.1966 11.8249 88.0121 12.1148 88.0648C12.4311 88.1176 12.6156 88.4338 12.5628 88.7238L11.7458 92.7036C11.6931 92.9671 11.4559 93.1516 11.1923 93.1516Z",
    fill: "#6E728F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4308 90.8323C11.8246 90.806 11.2184 90.7533 10.6385 90.6742C12.4308 81.1069 13.7749 68.245 9.00444 59.3102C10.454 58.5985 11.93 57.9133 13.3796 57.2017C16.885 65.0031 13.9067 82.6092 12.4308 90.8323Z",
    fill: "#292B3B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52077 90.5683C1.91457 90.3838 1.33473 90.1993 0.75489 89.9621C5.23547 81.2118 8.50365 67.4275 7.73932 57.4648C9.37341 57.3857 11.0075 57.333 12.6416 57.2803C12.009 67.243 6.39515 81.5808 2.52077 90.5683Z",
    fill: "#3B3E54"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4802 92.4134C10.4802 92.4134 10.1376 93.863 10.4802 93.9157C10.8228 93.9684 15.8569 94.1002 15.8833 93.863C15.9887 93.0723 11.8771 92.3343 11.4554 92.4134C11.0337 92.4925 10.5329 92.2025 10.4802 92.4134Z",
    fill: "#1A1C2E"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6978 60.4701C13.7489 60.1539 11.7722 60.6546 10.8234 60.4701C9.42649 60.1802 8.74123 60.2857 7.3707 60.3647C7.1862 56.0423 7.34434 51.509 7.02807 47.2393C6.949 46.3432 6.92264 45.816 7.08078 45.1308C7.31798 44.2346 7.76604 43.6021 8.37223 43.2858C9.11021 42.8905 10.0854 42.9168 11.0342 43.3912C11.166 43.444 11.3241 43.5494 11.4559 43.6548C12.0358 44.1029 12.5629 44.9463 12.642 46.554C12.8528 50.5865 13.9334 56.2795 14.6978 60.4701Z",
    fill: "#5BE4E8"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18451 58.7568C6.18451 58.7568 9.08371 59.7584 9.34727 60.47C9.61083 61.208 6.73799 60.5491 5.55196 59.1522L6.18451 58.7568Z",
    fill: "#6E728F"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39554 58.4932C6.13197 58.9412 5.84206 59.3629 5.5785 59.7583C-1.72221 54.0126 -1.27416 50.5336 6.6591 44.4452C7.87149 43.5228 7.9242 43.7336 8.50404 44.6561C8.71489 44.577 8.71489 44.577 8.50404 44.6561C9.08388 45.5786 8.63583 45.8421 7.687 46.5537C1.44055 51.377 0.070014 53.9599 6.39554 58.4932Z",
    fill: "#5BE4E8"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3193 52.8265C25.3193 52.8265 28.2185 51.8513 28.482 51.1134C28.7456 50.4017 25.8728 51.0079 24.6867 52.4312L25.3193 52.8265Z",
    fill: "#6E728F"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7151 53.3537C25.6887 52.8003 25.5833 52.2468 25.5042 51.6669C18.757 52.4576 15.3307 55.1196 12.3261 45.5259C11.878 44.05 11.5617 44.1817 10.6129 44.7616C10.4284 44.6034 10.4548 44.6034 10.6129 44.7616C9.66407 45.3414 9.79586 45.6313 10.4284 46.9492C14.6981 55.6204 17.3601 54.6716 25.7151 53.3537Z",
    fill: "#5BE4E8"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55699 40.676C9.47946 42.0992 11.2453 42.6264 12.1151 42.0465C12.9849 41.4667 12.6686 40.0434 11.7197 38.6202C10.7973 37.197 9.61124 36.907 8.71513 37.4869C7.87172 38.0667 7.63452 39.2528 8.55699 40.676Z",
    fill: "#6E728F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24031 41.5992C8.45116 41.9418 9.05735 42.1527 9.29456 41.9945C9.53177 41.8364 9.42635 41.5201 9.2155 41.2038C9.00464 40.8612 8.6093 40.6767 8.34574 40.8348C8.10853 40.9666 8.02946 41.2565 8.24031 41.5992Z",
    fill: "#6E728F"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76736 40.4394L10.5596 40.2549C10.586 40.4921 10.7704 42.8378 10.6914 43.7076C10.6387 43.9711 10.1906 44.1029 9.68984 43.9975C9.24178 43.8921 8.95186 43.6285 8.9255 43.3913C8.97822 42.8642 8.84643 41.3091 8.76736 40.4394Z",
    fill: "#6E728F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45265 41.1768C9.71621 40.8869 9.95342 41.1504 10.586 41.4931C11.2185 41.862 12.3518 41.7566 12.4309 40.2807C12.4836 39.3318 13.0108 40.8869 13.0108 40.8869C13.1162 41.6512 12.9053 42.1256 12.3782 42.4682C11.6666 42.9427 10.5069 42.8636 9.50536 42.2574C9.34723 41.8884 9.26815 41.3613 9.45265 41.1768Z",
    fill: "#1A1C2E"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4837 40.2288C12.4837 40.2288 12.4574 40.2288 12.431 40.2552C12.1148 40.4133 10.6915 41.2303 10.5597 41.8102C10.4016 42.4691 11.3241 41.5466 11.5876 41.1249C11.8776 40.7032 12.1938 40.7559 12.5101 40.6769C12.8 40.5978 12.9582 40.2024 12.4837 40.2288Z",
    fill: "#1A1C2E"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76588 39.912C7.76588 39.912 7.47595 38.8051 7.97672 37.988C8.47749 37.1973 9.90074 36.3539 11.0341 37.4345C11.0341 37.4345 11.772 38.2779 10.6914 39.0686C9.61082 39.8593 9.47904 39.1213 9.21548 40.0175C8.95191 40.9136 8.21394 40.7554 8.18758 40.9663L7.76588 39.912Z",
    fill: "#1A1C2E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4309 53.8809L12.0092 56.2003L10.5332 53.96L9.9007 44.5508H10.5332L12.4309 53.8809Z",
    fill: "#2B596E"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5174 59.8549L25.6301 59.1838L33.5147 37.008L35.402 37.6791L27.5174 59.8549Z",
    fill: "#292B3B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8739 60.6128L24.8691 59.5444L30.5906 43.4527L33.5954 44.521L27.8739 60.6128Z",
    fill: "#FF6D69"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3315 30.3452C48.0122 36.9079 40.7905 40.3342 34.2278 37.9885C27.6651 35.6692 24.2388 28.4475 26.5845 21.8848C28.9038 15.3221 36.1255 11.8957 42.6882 14.2415C49.2509 16.5872 52.6773 23.7825 50.3315 30.3452ZM49.2773 29.9762C51.3858 24.0197 48.2757 17.4569 42.3192 15.3221C36.3627 13.2136 29.8 16.3236 27.6651 22.2801C25.5302 28.2367 28.6666 34.7994 34.6232 36.9343C40.5797 39.0428 47.1424 35.9327 49.2773 29.9762Z",
    fill: "#292B3B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M45.7981 17.2981C48.1439 20.2764 48.9609 24.3879 47.5904 28.236C45.4555 34.1925 38.9191 37.3289 32.9363 35.194C31.6184 34.7196 30.4588 34.0607 29.4572 33.2173C30.7487 34.8778 32.5146 36.1692 34.6231 36.9336C40.5796 39.0421 47.1423 35.932 49.2772 29.9755C50.9113 25.3104 49.3826 20.2764 45.7981 17.2981Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.5637 28.2365C48.9342 24.3884 48.1172 20.3032 45.7714 17.2986C44.7699 16.4552 43.5839 15.7963 42.2924 15.3219C36.3359 13.2133 29.7731 16.3234 27.6383 22.2799C26.2677 26.1279 27.0848 30.2132 29.4305 33.2178C30.4321 34.0612 31.6181 34.7201 32.9095 35.1945C38.8924 37.303 45.4552 34.193 47.5637 28.2365Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4461 91.2279L91.2896 90.6217C91.1841 90.49 81.6168 76.1258 80.9052 66.1104L79.1393 66.1894C79.8773 76.4684 89.9981 90.6217 90.4461 91.2279Z",
    fill: "#FF6D69"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M73.104 93.1256C73.1567 92.9411 79.0868 75.7831 79.5085 66.1631L77.7427 66.1104C77.3473 75.5986 72.1551 92.6512 72.1024 92.8093L73.104 93.1256Z",
    fill: "#FF6D69"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9208 89.8051C90.9208 89.8051 92.0014 90.5167 91.8169 90.7539C91.6324 90.9911 88.5224 94.1011 88.3643 93.9694C87.8108 93.5213 89.972 90.5958 90.2883 90.4113C90.6046 90.2268 90.7627 89.6996 90.9208 89.8051Z",
    fill: "#1A1C2E"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5444 43.5495C68.5444 43.5495 67.6483 41.1774 67.0158 40.993C66.4096 40.8085 67.0158 43.1542 68.2282 44.103L68.5444 43.5495Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7554 43.3384C68.3601 43.4702 67.9911 43.6019 67.6221 43.7864C70.1786 49.7957 71.8654 52.1414 78.56 52.5104C79.5879 52.5631 79.6669 52.1678 79.5351 51.3771C79.6933 51.3243 79.7196 51.3243 79.5351 51.3771C79.4034 50.5864 79.0871 50.5337 78.191 50.4809C72.3399 50.2437 71.4701 48.2407 68.7554 43.3384Z",
    fill: "#FF8B87"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6171 78.788C81.3008 78.9988 81.0109 79.2361 80.721 79.4469C80.0357 79.9477 79.2714 80.343 78.507 80.712C78.059 80.9229 77.5846 81.1337 77.1102 81.2655C76.3722 81.45 75.6078 81.45 74.8435 81.3446C75.8451 74.5446 75.3443 68.3245 77.5319 61.8672C77.7427 61.9463 77.9536 62.0254 78.1908 62.1044C78.1908 61.8672 78.1644 61.6037 78.1644 61.3665C79.5613 61.5246 80.9845 61.6827 82.3814 61.8672C82.0124 68.2982 83.014 73.1477 84.938 77.8655C83.7783 77.8128 82.5923 78.1291 81.6171 78.788Z",
    fill: "#3C3F57"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M76.978 42.7588C77.4525 42.7061 78.0586 43.0487 78.2168 43.5231C78.4013 43.9975 78.0323 44.4983 77.5842 44.6564C77.1362 44.8146 76.2137 44.3401 76.0292 43.8657C75.8447 43.4177 76.3718 42.8115 76.978 42.7588Z",
    fill: "#1A1C2E"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5599 42.0995C79.4296 41.3879 80.9583 41.2561 81.9071 41.9413C82.8559 42.6266 82.8032 44.0498 82.1443 44.946C81.4854 45.8421 79.5087 46.3956 78.0064 45.4731C77.0576 44.8669 77.4529 42.9956 78.5599 42.0995Z",
    fill: "#1A1C2E"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0318 45.21C78.6644 44.6829 79.7977 44.5511 80.4566 45.0255C81.1419 45.5263 81.0892 46.5542 80.5884 47.2394C80.0876 47.9247 78.3745 48.1883 77.6892 47.6875C77.0039 47.2131 77.2148 45.8953 78.0318 45.21Z",
    fill: "#1A1C2E"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0603 46.1059C78.4278 47.4501 76.9782 48.109 76.1611 47.7136C75.3441 47.3183 75.4495 46.0532 76.082 44.709C76.7146 43.3649 77.6898 42.9959 78.5332 43.3649C79.3502 43.7602 79.6929 44.7617 79.0603 46.1059Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4555 46.844C79.2974 47.1603 78.7966 47.4239 78.5858 47.3185C78.3486 47.213 78.4276 46.9231 78.5594 46.6068C78.7176 46.2906 79.0338 46.0797 79.2447 46.1851C79.4819 46.2906 79.5873 46.5278 79.4555 46.844Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6401 45.3418C79.6401 45.3418 79.7719 44.3403 79.2184 43.7077C78.6913 43.0752 77.3734 42.5217 76.53 43.576C76.53 43.576 76.0029 44.393 77.0308 44.9465C78.0587 45.5 78.0851 44.8674 78.4013 45.6054C78.7176 46.3434 79.3502 46.1325 79.4029 46.2907L79.6401 45.3418Z",
    fill: "#1A1C2E"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7938 64.7135C77.9798 64.7398 78.8759 64.3445 79.8775 63.7383C80.6418 63.2639 81.6433 63.0794 82.434 62.7368C83.0139 59.0732 82.1968 53.143 80.7736 50.8237C79.5085 48.7679 79.5085 49.1105 79.0604 48.926C78.4279 48.6625 77.6899 48.7415 77.1891 49.216L77.1628 49.2423C76.5829 49.7958 76.5566 51.0082 76.4775 52.2733C76.3984 53.5384 75.8977 53.3012 77.031 55.4888C77.5317 56.4112 76.7674 62.8158 76.7938 64.7135Z",
    fill: "#FFA9A6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5865 46.2913L77.0315 46.423C77.0579 46.6339 77.2687 48.6633 77.4796 49.4013C77.585 49.6122 77.9803 49.6649 78.3757 49.4804C78.7183 49.3222 78.9555 49.0323 78.9292 48.8215C78.7974 48.3998 78.6392 47.0556 78.5865 46.2913Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3934 92.3612C73.3934 92.3612 73.7096 93.6263 73.3934 93.6527C73.0771 93.679 68.7019 93.8108 68.6756 93.6263C68.5965 92.941 72.181 92.2821 72.5236 92.3612C72.8926 92.4403 73.367 92.1767 73.3934 92.3612Z",
    fill: "#1A1C2E"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0655 64.1074C82.0655 64.1074 80.2469 66.0578 80.3523 66.7167C80.4577 67.3756 82.3817 65.7152 82.7244 64.1338L82.0655 64.1074Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5645 64.5287C81.9071 64.7923 82.197 65.0031 82.5924 65.2931C86.8621 58.0714 85.8078 55.8048 80.2467 50.0591C79.4033 49.1893 77.8482 50.6126 79.4033 51.9304C84.9117 56.5955 84.5164 57.8079 81.5645 64.5287Z",
    fill: "#FF8B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/CreateAccount.21d16c2885d5721f26e22a787a910cfd.svg";
export { ForwardRef as ReactComponent };